import { type SvgIconProps } from "@mui/material/SvgIcon";
import { type FC } from "react";
import { matchPath, useLocation } from "react-router";

import { ROUTES } from "~/constants/routing";
import {
  DashboardsTabEnum,
  iconByDashboardsTabEnum,
  labelByDashboardsTabEnum,
} from "~/feature/dashboards/components/DashboardsSidebar/constants";

export type DashboardsTab = {
  key: string;
  label: string;
  icon: FC<SvgIconProps>;
  to: string;
  isActive: boolean;
};

const dashboardsTabConfig = [
  {
    key: DashboardsTabEnum.HIGHLIGHTS,
    label: labelByDashboardsTabEnum[DashboardsTabEnum.HIGHLIGHTS],
    icon: iconByDashboardsTabEnum[DashboardsTabEnum.HIGHLIGHTS],
    path: ROUTES.highlights.path,
    to: ROUTES.highlights.createURL(),
  },
  {
    key: DashboardsTabEnum.WORLD_CUP,
    label: labelByDashboardsTabEnum[DashboardsTabEnum.WORLD_CUP],
    icon: iconByDashboardsTabEnum[DashboardsTabEnum.WORLD_CUP],
    path: ROUTES.worldCup.path,
    to: ROUTES.worldCup.createURL(),
  },
];

export const useDashboardsTabs = (): DashboardsTab[] => {
  const { pathname } = useLocation();

  return dashboardsTabConfig.map(({ key, label, to, path, icon }) => ({
    key,
    label,
    icon,
    to,
    isActive: !!matchPath({ path, end: true }, pathname),
  }));
};
